export enum PillStatus {
  ToDo,
  Discontinued,
  Delayed,
  Done,
  InProgress,
}
